export default __webpack_public_path__ + "static/media/PFDINTextPro-Regular.d360d9d1.otf";